<script setup lang="ts">
const { auth } = useAuth();
</script>

<template>
  <a v-if="auth" :href="auth.is_logged_in ? auth.logout_url : auth.login_url">
    {{ auth.is_logged_in ? __("Logout", "gestes") : __("Login", "gestes") }}
  </a>
</template>
